import {
  collection,
  doc,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { AuditoriaAtor } from '../models/solicitacao.types';
import {
  COMENTARIO_SOLICITACAO_MAX_CARACTERES,
  type ComentarioSolicitacao,
} from '../models/comentarioSolicitacao.types';

function validarTexto(texto: string): string {
  const limpo = texto.trim();
  if (!limpo) throw new Error('Escreva algo antes de postar.');
  if (limpo.length > COMENTARIO_SOLICITACAO_MAX_CARACTERES) {
    throw new Error(`A observação pode ter no máximo ${COMENTARIO_SOLICITACAO_MAX_CARACTERES} caracteres.`);
  }
  return limpo;
}

/**
 * Operações Firestore para a subcoleção si_solicitacoes/{id}/comentarios (Observações da
 * Solicitação). Autorização (quem posta/edita/exclui) fica em firestore.rules.
 */
class ComentarioSolicitacaoServiceClass {
  private colRef(solicitacaoId: string) {
    return collection(db, 'si_solicitacoes', solicitacaoId, 'comentarios');
  }

  async getBySolicitacao(solicitacaoId: string): Promise<ComentarioSolicitacao[]> {
    const snap = await getDocs(query(this.colRef(solicitacaoId), orderBy('criadoEm', 'asc')));
    return snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<ComentarioSolicitacao, 'id'>) }));
  }

  async create(solicitacaoId: string, texto: string, autor: AuditoriaAtor, autorEmail: string): Promise<string> {
    const docRef = await addDoc(this.colRef(solicitacaoId), {
      texto: validarTexto(texto),
      autor: { id: autor.id, name: autor.name, avatar: autor.avatar ?? null },
      autorEmail,
      criadoEm: serverTimestamp(),
    });
    return docRef.id;
  }

  async update(solicitacaoId: string, comentarioId: string, texto: string): Promise<void> {
    await updateDoc(doc(this.colRef(solicitacaoId), comentarioId), {
      texto: validarTexto(texto),
      editadoEm: serverTimestamp(),
    });
  }

  async delete(solicitacaoId: string, comentarioId: string): Promise<void> {
    await deleteDoc(doc(this.colRef(solicitacaoId), comentarioId));
  }
}

export const comentarioSolicitacaoService = new ComentarioSolicitacaoServiceClass();
